import type { ICellRendererParams } from 'ag-grid-community';
import type { FC, PropsWithChildren } from 'react';
import { ColorLevel } from 'types/sgBootstrap';

export type StatusToColorMapper<T extends string | boolean | null | undefined> = (status: T) => ColorLevel | undefined;

export const makeStatusCellRenderer: <T extends string | boolean | null | undefined>(
  color: StatusToColorMapper<T>,
  textFormatter?: (value: T) => string,
) => FC<PropsWithChildren<ICellRendererParams>> =
  (getColor, textFormatter) =>
  ({ value }) => {
    const renderedValue = textFormatter ? textFormatter(value) : value;
    const color = getColor(value) ?? 'primary';
    if (!renderedValue) {
      return null;
    }
    if (color === undefined) {
      return renderedValue;
    }

    return <span className={`badge rounded-pill badge-sm p-2 badge-discreet-${color}`}>{renderedValue}</span>;
  };
